(() => {
  const heroes = document.querySelectorAll('main[data-template="index"] .hero[id*="hero_FTBzCd"], main[data-template="index"] .hero[id*="hero_c74zGB"]');

  if (!heroes.length) return;

  const syncHeroLayer = (hero) => {
    const container = hero.querySelector('.hero__container') || hero;
    const rect = container.getBoundingClientRect();
    const scale = Math.max(rect.width / 1600, rect.height / 900);
    const renderedWidth = 1600 * scale;
    const renderedHeight = 900 * scale;

    hero.style.setProperty('--dc-hero-scale', scale.toString());
    hero.style.setProperty('--dc-hero-offset-x', `${(rect.width - renderedWidth) / 2}px`);
    hero.style.setProperty('--dc-hero-offset-y', `${(rect.height - renderedHeight) / 2}px`);
  };

  const syncAll = () => heroes.forEach(syncHeroLayer);
  syncAll();
  window.addEventListener('resize', syncAll, { passive: true });

  if (!window.matchMedia('(min-width: 750px)').matches || !('IntersectionObserver' in window)) {
    heroes.forEach((hero) => hero.classList.add('daochant-hero-copy--active', 'daochant-hero-copy--played'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        syncHeroLayer(entry.target);
        entry.target.classList.add('daochant-hero-copy--active', 'daochant-hero-copy--played');
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '-35% 0px -35% 0px',
      threshold: 0,
    }
  );

  heroes.forEach((hero) => observer.observe(hero));
})();
